import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";

import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import Math from "exact-math";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-hardware-mapping",
  templateUrl: "./hardware-mapping.component.html",
  styleUrls: ["./hardware-mapping.component.css"],
})
export class HardwareMappingComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");

  alphaPattern = "[a-zA-Z .,]*";

  MappingForm: FormGroup;

  showLoadMore = false;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  swal: any;
  total_count = 0;
  mapcreate: any;
  mappingList: any[];
  getmapping: any;
  editmapping: any;
  deletemapping: any;
  editstatus = false;
  mapupdate: any;
  mapstatusupdate: any;
  editid: any;
  department: any;
  dept = [];
  classroom: any;
  class: any;
  audiodevice: any;
  audio: any;
  raspberry: any;
  ras: any;
  camera: any;
  cam: any;
  cam_id: any;
  ras_id: any;
  editbut: boolean;
  camid: any;
  rasid: any;
  classname:any;
  devicename:any;
  isactiveswitch: any;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  total: number;
  p: number;
  pagedItems: any[];
  writehide = false;
  writeaccess = this.ls.get("write_access");
  searchForm: FormGroup;
  filtervalues: boolean;
  chiparray: any[];
  entryFields: boolean = false;
  createNew: boolean = true;

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {}

  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      camip: [""],
      ras_name: [""],
      classroom_name:[""],
      audio_device_name:[""],
      
    });
    this.MappingForm = this.fb.group({
      id: [""],
      audio_id: ["", [Validators.required]],
      class_room_no: ["", [Validators.required]],
      camera_id: ["", [Validators.required]],
      raspberry_id: ["", [Validators.required]],
    });
    this.page = 1;
    if (this.ls.get("write_access") == 0) {
      this.writehide = true;
    }
    this.getcamera();
    this.getclassroom();
    this.getraspberry();
    this.getAudio();
    await this.getMapping();
    await this.getPage(this.page, true);
    this.MappingForm.reset();
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.MappingForm.reset();
    this.submitted = false;
  }

  cancelFields(isEditbut?) {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.MappingForm.reset();
    this.createNew = true;
    if (isEditbut) {
      this.editbut = false;
    }
  }

  get forms() {
    return this.MappingForm.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }
  async getclassroom() {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter,true
    );

    this.class = this.classroom["content"];
  }
  async getAudio() {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.audiodevice = await this.globalService.get(
      "audiodevice/list/dropdown",
      filter,true
    );

    this.audio = this.audiodevice["content"];
  }
  async getraspberry() {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.raspberry = await this.globalService.get(
      "raspberry/list/dropdown",
      filter,true
    );

    this.ras = this.raspberry["content"];
  }
  Filter(camid, rasid, classname, devicename) {
    this.filtervalues = true;
    this.chiparray = [];

    if (this.camid != undefined && this.camid != "") {
      var cam = this.cam.filter((x) => x.id == this.camid);
      this.chiparray.push("Camera Name:" + " " + cam[0].device_name);
    }
    if (this.rasid != undefined && this.rasid != "") {
      var ras = this.ras.filter((x) => x.id == this.rasid);
      this.chiparray.push("Raspberry Name:" + " " + ras[0].name);
    }
    if (this.classname != undefined && this.classname != "") {
      var classN = this.class.filter((x) => x.id == this.classname);
      this.chiparray.push("Classroom Name:" + " " + classN[0].name);
    }
    if (this.devicename != undefined && this.devicename != "") {
      var aDev = this.audio.filter((x) => x.id == this.devicename);
      this.chiparray.push("Audio Device Name:" + " " + aDev[0].device_name);
    }
    this.camid = camid;
    this.rasid = rasid;
    this.classname = classname;
    this.devicename = devicename;
    this.pageshow = true;
    this.page = 1;
    this.getMapping();
  }
  res() {
    this.filtervalues = false;
    this.camid = null;
    this.rasid = null;
    this.classname = null;
    this.devicename = null;
    this.MappingForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getMapping();
  }
  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall){
      await this.getMapping();
    }   
    const res = await this.serverCall(this.mappingList, page);
    this.total = this.total_count;
    this.p = page;

    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  async getcamera() {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.camera = await this.globalService.get("camera/list/dropdown", filter,true);                             

    this.cam = this.camera["content"];
  }
  async createMapping(form: FormGroup) {
    this.submitted = true;

    if (this.MappingForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      audio_device_id: form.value.audio_id,
      class_room_id: form.value.class_room_no,
      camera_id: form.value.camera_id,
      raspberry_id: form.value.raspberry_id,
    };
    this.mapcreate = await this.globalService.create(
      "mapping/create",
      inputData
    );

    if (this.mapcreate["status"] === 200) {
      Swal.fire("Success!", this.mapcreate["message"], "success");
      this.pageshow = true;
      this.getMapping();
      this.reset();
      this.entryFields = false;
      this.createNew = true;
    }
    this.cancelFields();
    this.spinner.hide();
  }

  async getMapping() {
    this.spinner.show();
    if (this.page === 1) {
      this.mappingList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      camera_id: this.camid ? this.camid : "",
      raspberry_id: this.rasid ? this.rasid : "",
      class_room_id:this.classname ? this.classname : "",
      audio_id:this.devicename ? this.devicename : "",
      page_size: this.page_size,
    };

    this.getmapping = await this.globalService.get("mapping/list", filter);
    this.total_count = this.getmapping["content"].count;

    if (this.getmapping["content"]["rows"].length < this.page_size) {
      this.showLoadMore = true;
    }

    if (this.getmapping["status"] === 200) {
      this.mappingList = this.getmapping["content"]["rows"];

      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    } else {
      this.showLoadMore = true;
    }

    (error) => {
      this.mappingList = [];
      this.spinner.hide();
      this.showLoadMore = true;
    };

    this.spinner.hide();
  }
  editMapping(id, camera_id, raspberry_id) {
    this.spinner.show();
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.editbut = true;
        this.openField();
        this.spinner.show();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          camera_id: camera_id,
          raspberry_id: raspberry_id,
        };

        this.editmapping = await this.globalService.get("mapping/get", filter);
        let comp_details = this.editmapping["content"];

        if (this.editmapping["status"] === 200) {
          this.MappingForm.controls["id"].setValue(comp_details.id);
          this.MappingForm.controls["audio_id"].setValue(
            comp_details.audio_device_id
          );
          this.MappingForm.controls["class_room_no"].setValue(
            comp_details.class_room_id
          );
          this.MappingForm.controls["camera_id"].setValue(
            comp_details.camera_id
          );
          this.MappingForm.controls["raspberry_id"].setValue(
            comp_details.raspberry_id
          );
          this.editid = comp_details.id;
          this.cam_id = comp_details.camera_id;
          this.ras_id = comp_details.raspberry_id;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
    this.spinner.hide();
  }
  reset() {
    this.submitted = false;
    this.MappingForm.reset();
    this.editstatus = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getMapping();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getMapping();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getMapping();
  }

  async updateMapping(form: FormGroup) {
    this.submitted = true;

    if (this.MappingForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      id: form.value.id,
      vendor_id: this.ls.get("vendor_id"),
      user_id: this.ls.get("createdBy"),
      audio_device_id: form.value.audio_id,
      class_room_id: form.value.class_room_no,
      camera_id: form.value.camera_id,
      raspberry_id: form.value.raspberry_id,
    };

    this.mapupdate = await this.globalService.update(
      "mapping/update",
      inputData
    );

    if (this.mapupdate["status"] === 200) {
      Swal.fire("Success!", this.mapupdate["message"], "success");
      this.editbut = false;
      this.pageshow = true;
      this.getMapping();
      this.reset();
      this.entryFields = false;
      this.createNew = true;
    }
    this.cancelFields();
    this.spinner.hide();
  }
  // Modal
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  async deleteMapping(id, camera_id, raspberry_id, classroom_id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          camera_id: camera_id,
          raspberry_id: raspberry_id,
          classroom_id: classroom_id,
        };
        this.deletemapping = await this.globalService.delete(
          "mapping/delete",
          filter
        );
        if (this.deletemapping["status"] === 200) {
          this.mappingList = [];
          Swal.fire("Success!", this.deletemapping["message"], "success");
          this.pageshow = true;
          this.getMapping();
        }
      }
    });
    this.spinner.hide();
  }

  formAddReset() {
    this.MappingForm.reset();
    this.editbut = false;
  }
  formupdateReset() {
    this.MappingForm.controls["id"].setValue(this.editmapping["content"].id);
    this.MappingForm.controls["audio_id"].setValue(
      this.editmapping["content"].audio_device_id
    );
    this.MappingForm.controls["class_room_no"].setValue(
      this.editmapping["content"].class_room_id
    );
    this.MappingForm.controls["camera_id"].setValue(
      this.editmapping["content"].camera_id
    );
    this.MappingForm.controls["raspberry_id"].setValue(
      this.editmapping["content"].raspberry_id
    );
    this.MappingForm.reset();
    this.MappingForm.get('id').setValue(this.editmapping["content"].id);
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getMapping();
  }
}
